var _defs, _path, _path2, _path3, _g, _g2, _path4, _rect, _rect2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBandNewsLogoBranco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 111.87 105.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: .6px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.36,71.72h-.15c-2.15,0-3.91,1.76-3.91,3.91v19.45c0,2.15,1.76,3.91,3.91,3.91h.15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.5,99h.15c2.15,0,3.91-1.76,3.91-3.91v-19.45c0-2.15-1.76-3.91-3.91-3.91h-.15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.25,80.03l-31.07-.21v6.83s-.54,5.1,4.78,3.09c4.8-1.82,22.84-8.26,26.29-9.49v-.21Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.92,2.06h5.89c.8,0,1.29.07,1.68.26.52.27.96.93.96,1.71,0,.67-.27,1.38-1.09,1.62v.02c.43.12.75.47.8,1.09l.12,1.55c.03.32.16.61.35.83h-3.05c-.11-.21-.1-.52-.15-1.34-.03-.52-.21-.84-.72-.84h-1.98v2.18h-2.8V2.06h0ZM12.72,5.18h1.98c.56,0,.77-.22.77-.66,0-.55-.35-.66-.81-.66h-1.94v1.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.46,2.06h3.43l3.01,7.08h-2.97l-.3-.81h-2.92l-.3.81h-2.97l3.01-7.08h0ZM22.56,0h3l-1.52,1.43h-2.39l.9-1.43ZM23.19,4.2h-.02l-.83,2.4h1.69l-.83-2.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.26,2.06h5.44c2.4,0,3.67.93,3.67,3.54s-1.26,3.54-3.61,3.54h-5.5V2.06h0ZM31.06,7.36h1.61c1.28,0,1.79-.63,1.79-1.75s-.52-1.76-1.79-1.76h-1.61v3.51h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.39,
    y: 2.06,
    width: 2.8,
    height: 7.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.05,1.82c1.69,0,4.84.12,4.84,3.79s-3.14,3.79-4.84,3.79-4.84-.11-4.84-3.79,3.14-3.79,4.84-3.79M47.05,7.6c1.15,0,1.86-.56,1.86-2s-.71-2-1.86-2-1.86.57-1.86,2,.71,2,1.86,2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.53,23.13c0-.73-.34-1.26-1.82-1.26h-5.53v2.57h5.53c1.48,0,1.82-.53,1.82-1.31h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "43.5 23.05 43.45 23.05 41.27 29.8 45.68 29.8 43.5 23.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.44,28.96h-6.26v3.13h6.26c1.45,0,1.9-.67,1.9-1.56s-.44-1.56-1.9-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.9,22.04h-4.21v9.88h4.21c3.35,0,4.7-1.79,4.7-4.94s-1.35-4.94-4.7-4.94h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.27,12.24v50.97h103.24V12.24H4.27ZM10.01,17.02h16.68c3.79,0,5.48,1.79,5.48,4.97,0,1.76-.81,3.29-2.21,3.88v.06c2.39.67,3.17,3.07,3.17,4.55,0,.58-.05,1.14-.13,1.66l5.99-15.11h8.99l6.87,17.32v-17.32h8.36l7.43,11.05h.08v-11.05h7.01v19.92h-8.03l-7.79-11.16h-.05v11.16h-13.78l-.78-2.29h-7.64l-.78,2.29h-7.79l.92-2.32c-1.07,1.47-3,2.32-6.13,2.32h-15.87v-19.92h0ZM32.21,58.52h-7.81l-7.58-10.85h-.05v10.85h-6.82v-19.37h8.13l7.22,10.74h.08v-10.74h6.82v19.37h0ZM91.17,59.44c-5.63,0-11.77-.84-11.8-6.69h8.82c.03.67.26,1.11.78,1.42.55.28,1.35.42,2.49.42,2.28,0,2.9-.67,2.9-1.62,0-.58-.34-1.17-1.32-1.34l-8.35-1.34c-3.37-.55-4.88-2.56-5.04-5.13l-3.64,13.35h-7l-2.45-10.74h-.05l-2.47,10.74h-7l-4-14.73v.08h-12.05v2.61h11.19v4.72h-11.19v2.61h12.05v4.72h-19.17v-19.37h24.81l2.32,11.83h.05l2.65-11.83h5.68l2.63,11.83h.05l2.32-11.83h6.9l-.53,1.95c1.74-2.24,5.32-2.94,9.58-2.94,8.25,0,11.64,2.31,11.9,6.52h-8.51c0-.81-.44-1.31-1.11-1.59-.65-.31-1.48-.42-2.28-.42-2.18,0-2.93.58-2.93,1.42,0,.56.23.92.96,1.03l8.74,1.39c3.68.58,5.96,2.42,5.96,5.79,0,4.85-3.68,7.13-11.9,7.13h0ZM93.78,36.94h-14.42v-19.92h14.26c6.29,0,9.61,2.62,9.61,9.96s-3.3,9.96-9.46,9.96h0Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.23,65.15v11.17c0,2.15,1.76,3.91,3.91,3.91h99.32v-15.09H4.23ZM88.48,70.14h-4.88v1.31h4.19v2.5h-4.19v4h-3.23v-10.49h8.11v2.69h0ZM100.34,77.94h-2.83v-6.73h-.03l-1.69,6.73h-2.23l-1.69-6.73h-.03v6.73h-2.83v-10.49h4.26l1.39,6.17h.03l1.39-6.17h4.26v10.49Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.27,
    y: 97.81,
    width: 2.05,
    height: 2.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 105.46,
    y: 97.81,
    width: 2.05,
    height: 2.05
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.26,105.12H7.02c.21-5.26,3.32-7.14,7.35-8.26l3.82-1.08c.92-.25,1.65-.82,1.65-1.6,0-1.01-.98-1.72-3.04-1.74-1.95,0-3.43.76-3.59,2.59h-5.63c.32-4.67,4.12-6.11,9.25-6.11s8.65,1.76,8.65,5.33c0,6-10.39,4.44-12.63,7.35h12.43v3.52h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.52,97.27c0,4.23-2.36,8.22-9.29,8.22s-9.29-3.98-9.29-8.22,2.31-8.35,9.29-8.35,9.29,4.01,9.29,8.35ZM32.19,97.27c0,3.78,2.22,4.69,4.03,4.69s4.03-.8,4.03-4.69-2.22-4.83-4.03-4.83-4.03.92-4.03,4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.04,93.79h4.62l4.87,11.33h-4.05l-.68-1.84h-4.95l-.68,1.84h-4.05l4.92-11.33h0ZM54.34,96.65h-.03l-1.57,4.28h3.17l-1.57-4.28h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.83,93.79h4.35l5.25,7.09h.03v-7.09h3.65v11.33h-4.17l-5.43-7.16h-.03v7.16h-3.65v-11.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.8,93.44c4,0,7.38,1.32,7.38,6.02s-3.38,6.02-7.38,6.02-7.38-1.32-7.38-6.02,3.38-6.02,7.38-6.02ZM83.8,102.93c2.03,0,3.38-1.09,3.38-3.48s-1.35-3.48-3.38-3.48-3.38,1.11-3.38,3.48,1.37,3.48,3.38,3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.33,97.11c-.11-.78-.73-1.32-2.46-1.32-1.27,0-1.97.37-1.97,1.11,0,.38.27.6.84.7.95.16,3.86.59,4.97.78,2.11.37,3.38,1.22,3.38,3.22,0,3.84-4.98,3.87-6.54,3.87-3.84,0-6.62-.68-6.84-3.84h4.48c.1.86.57,1.4,2.54,1.4.95,0,1.98-.22,1.98-1.19,0-.6-.48-.81-1.79-1.02l-3.78-.57c-2.33-.35-3.24-1.52-3.24-3.21,0-1.49.92-3.6,5.89-3.6,4.11,0,6.59.98,6.82,3.67h-4.28,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandNewsLogoBranco);
export default __webpack_public_path__ + "static/media/band_news_logo_branco.827808980c84caa0bf770375adb79eaa.svg";
export { ForwardRef as ReactComponent };